import Assets from "../../pages/Assets"
import BrowerNotSupported from "../../pages/BrowerNotSupported"
import { BurnProxyToken } from "../../pages/BurnProxyToken"
import Config from "../../pages/Config"
import Home from "../../pages/Home"
import MintDetails from "../../pages/ProxyTokenDetails"
import NotFoundPage from "../../pages/NotFoundPage"
import ProxyTokenList from "../../pages/ProxyTokenList"
import { TermsAndConditions } from "../../pages/TermsAndConditions/TermsAndConditions"
import TestPage from "../../pages/TestPage"
import { VerifySignature } from "../../pages/VerifySignature"
import PrivacyPolicy from "../../pages/privacyPolicy/PrivacyPolicy"
import { withHeader } from "../../shared/hocs/withHeader"
import { RouteDefinition } from "../../utils/type"
import { assetDetailsPath, browserNotSupported, burnTokenPagePath, privacyPath, proxyTokensPath, rootPath, termsPath, testpagePath, tokenDetailsPath, verifyPagePath, walletConnectPath } from "./path"

const notFoundRoute: RouteDefinition = {
  path: '*',
  element: NotFoundPage,
  protected: false,
  isHideSidebar: true,
  isHideNavbar: true,
  title: '',
}
const routes = [
  {
    path: rootPath,
    element: Home,
    title: 'Home',
  },
  {
    path: walletConnectPath,
    element: Assets,
    title: 'Login',
  },
  {
    path: assetDetailsPath,
    element: Config,
    title: 'Config',
  },
  {
    path: proxyTokensPath,
    element: ProxyTokenList,
    title: 'Token List',
  },
  {
    path: tokenDetailsPath,
    element: MintDetails,
    title: 'Mint Details',
  },
  {
    path: testpagePath,
    element: TestPage,
    title: 'Mint Details',
  },
  {
    path: privacyPath,
    element: PrivacyPolicy,
    title: 'Privacy Policy'
  },
  {
    path: termsPath,
    element: TermsAndConditions,
    title: 'Terms And Conditions'
  },
  {
    path: verifyPagePath,
    element: VerifySignature,
    title: 'Verify Signature'
  },
  {
    path: burnTokenPagePath,
    element: BurnProxyToken,
    title: 'Burn Token'
  },
  {
    path: browserNotSupported,
    element: BrowerNotSupported,
    title: 'Brower Not Supported'
  }
]

export const userRoutes: RouteDefinition[] = [
  ...routes,
  notFoundRoute,
]
  .map((r) => ({
    ...r,
    element: withHeader(r),
  }))
  .concat()
